import { types, API_URL } from './types';
import { axiosApi } from './index';

export const createOffer = (
  numerointerno,
  name,
  rut,
  email,
  phone,
  obs,
  price,
  iva,
  comission,
  wayToPay,
  version,
) => {
  const url = `${API_URL}/item/offer`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      data: {
        numerointerno: numerointerno,
        name: name,
        rut: rut,
        email: email,
        phone: phone,
        obs: obs,
        price: price,
        iva: iva,
        comission: comission,
        wayToPay: wayToPay,
        version: version,
      },
    };

    axiosApi
      .post(url, params)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['error'] = true;
          outputData['message'] = data.message || 'Error al crear oferta';
          dispatch(setCreateOffer(outputData));
        } else {
          outputData['data'] = data.url;
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          dispatch(setCreateOffer(outputData));
        }
      })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para crear ofertas.' :
          status === 404 ? 'Bien no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setCreateOffer({ status: 'danger', error: true, message }));
      });
  };
};

export const setCreateOffer = (data) => ({
  type: types.createOffer,
  payload: data,
});

export const getOffer = (filters) => {
  let url = `${API_URL}/item/offer?`;
  let filterString = '';
  if (filters) {
    Object.keys(filters).map((filter) => {
      filterString += `&${filter}=${filters[filter]}`;
    });
  }

  url += filterString;

  return (dispatch) => {
    let outputData = {};

    axiosApi
      .get(url)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['error'] = true;
          outputData['message'] = data.message || 'Error al cargar ofertas';
          dispatch(setGetOffer(outputData));
        } else {
          outputData['data'] = data.data;
          outputData['message'] = data.message;
          dispatch(setGetOffer(outputData));
        }
      })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para ver ofertas.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetOffer({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetOffer = (data) => ({
  type: types.getOffer,
  payload: data,
});

export const updateOffer = (
  id,
  numerointerno,
  name,
  rut,
  email,
  phone,
  obs,
  price,
  iva,
  comission,
  wayToPay,
  version,
) => {
  const url = `${API_URL}/item/offer`;

  return (dispatch) => {
    let outputData = {};
    let params = {
      data: {
        id: id,
        numerointerno: numerointerno,
        name: name,
        rut: rut,
        email: email,
        phone: phone,
        obs: obs,
        price: price,
        iva: iva,
        comission,
        wayToPay: wayToPay,
        version: version,
      },
    };

    axiosApi
      .put(url, params)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['error'] = true;
          outputData['message'] = data.message || 'Error al actualizar oferta';
          dispatch(setUpdateOffer(outputData));
        } else {
          outputData['data'] = data.url;
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          dispatch(setUpdateOffer(outputData));
        }
      })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para editar ofertas.' :
          status === 404 ? 'Oferta no encontrada.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setUpdateOffer({ status: 'danger', error: true, message }));
      });
  };
};

export const setUpdateOffer = (data) => ({
  type: types.updateOffer,
  payload: data,
});

export const exportOffer = () => {
  const url = `${API_URL}/item/offer/export`;

  return (dispatch) => {
    let outputData = {};

    axiosApi
      .get(url, { responseType: 'blob' })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['error'] = true;
          outputData['message'] = data.message || 'Error al exportar ofertas';
          dispatch(setExportOffer(outputData));
        } else {
          //download data blob xlsx
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          );

          const link = document.createElement('a');
          link.href = url;
          const date = new Date();
          link.setAttribute(
            'download',
            `Ofertas_${date.getDate()}-${
              date.getMonth() + 1
            }-${date.getFullYear()}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          outputData['data'] = data.data;
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          dispatch(setExportOffer(outputData));
        }
      })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para exportar ofertas.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setExportOffer({ status: 'danger', error: true, message }));
      });
  };
};

export const setExportOffer = (data) => ({
  type: types.exportOffer,
  payload: data,
});
